import React from 'react';

const CopyrightAndVersion = () => (
  <p className="CopyrightAndVersion" data-html2canvas-ignore="true">
    &copy; 2019 LANDMARKS ID Pty Ltd - v{process.env.REACT_APP_VERSION}
  </p>
);

export default CopyrightAndVersion;
